import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory("/mobile/town"),
  routes,
});

router.afterEach(() => {
  window.TrackKit.umengAdapter.trackPageView();
});
export default router;
